import React, { useState, useEffect, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import Form, { SimpleItem, GroupItem, Label, RequiredRule, StringLengthRule } from 'devextreme-react/form';
import { useDispatch, useSelector } from 'react-redux'
import { dialogTraslate } from '../../../store/traslate/traslateDialogReducer';
import { createStoreLocal } from '../../../utils/proxy';
import { editorOptionsSelect } from '../../../data/app';
import { DataGrid } from 'devextreme-react';
import { Column, Editing, Lookup, RequiredRule as RuleRequired, Button as ButtonGrid, Paging, Pager } from 'devextreme-react/data-grid';
import ProductDDBComponent from '../../../components/dropdown/ProductDDBComponent';
import uri from '../../../utils/uri';
import { cellRender, formatId, onCellPrepared } from '../../../utils/common';
import http from '../../../utils/http';
import useProducts from '../../../hooks/useProducts';
import gridsHelper from '../../../utils/gridsHelper';
import ButtonForm from '../../../components/buttons/ButtonForm';
import notify from 'devextreme/ui/notify';
import { stepsTraslate, typeTraslate } from '../../../data/enums';
import { defaultLabels, traslateDefault } from '../../../data/defaultObjects';

const Nuevo = props => {

    const exists = true;
    const active = true;

    const { stepId, type } = props;

    const isCreate = type == typeTraslate.create;

    const { traslateDialog: { open, id, editing }, user } = useSelector(store => store);

    const [areaSourceId, setAreaSourceId] = useState(0);
    const { products, setProducts } = useProducts({ areaId: areaSourceId, exists, active });
    const [traslate, setTraslate] = useState({ ...traslateDefault, stepId: 1 });
    const [saving, setSaving] = useState(false);
    const [details, setDetails] = useState([]);

    let refForm = useRef();
    let refGrid = useRef();

    useEffect(() => {

        if (id == 0) {
            setTraslate({ ...traslate, areaId: user.areaId, stepId: stepId });
            setDetails([]);
        }


        if (id > 0) {

            http(uri.traslates.getById(id)).asGet().then(resp => {

                setTraslate({ ...withOutDetaill(resp) });

                http(uri.products.getByArea(resp.areaSourceId)).asGet({ exists }).then(data => {

                    setProducts(data);

                    let arr = resp.traslateDetails.map(prod => {

                        let info = data.find(x => x.id == prod.productId);
                        prod['internalCode'] = info.internalCode;
                        prod['presentation'] = info.presentation;
                        prod['um'] = info.um;
                        prod['family'] = info.family;

                        return prod;
                    })

                    setDetails(arr);

                })


            });

        }


    }, [open]);

    const dispatch = useDispatch();
    const onToolbarPreparing = areaSourceId > 0 ? gridsHelper(refGrid, { text: 'Agregar producto', icon: 'plus' }) : undefined;

    const close = load => {

        refForm.current.instance.resetValues();
        refGrid.current.instance.cancelEditData();
        dispatch(dialogTraslate({ open: false, id: 0, editing: false }));
        if (load) {
            let { onSave } = props;
            onSave();
        }

    }

    const onHiding = ({ load }) => close(load);

    const crearTraslado = (e) => {

        let result = refForm.current.instance.validate();

        if (result.isValid) {

            setSaving(true);
            let data = { ...traslate, traslateDetails: [...details] };

            const url = editing ? `${uri.traslates.insert}/asEdit` : uri.traslates.insert;

            http(url).asPost(data).then(resp => {

                setSaving(false);
                notify('Soliictud de traslado registrado correctamente');
                close(true);

            }).catch(err => {

                setSaving(false);
                notify(err, 'error', 5000);

            });

        }

    }

    const despacharTraslado = () => {

        setSaving(true);
        let data = { ...traslate, id, traslateDetails: [...details] };

        http(uri.traslates.insert).asPost(data).then(resp => {

            setSaving(false);
            notify('Traslado registrado correctamente');
            close(true);

        }).catch(err => {

            setSaving(false);
            notify(err, 'error', 5000);

        });

    }

    const setCellValue = (prop, newData, value, currentRowData) => {

        newData[prop] = value || 0;
        if (prop == 'productId' && value) {

            let info = products.find(x => x.id == value);
            newData['internalCode'] = info.internalCode;
            newData['presentation'] = info.presentation;
            newData['um'] = info.um;
            newData['family'] = info.family;
            newData['cost'] = info.cost;
            newData['quantityResponse'] = 0;
            !currentRowData['quantityRequest'] && (newData['quantityRequest'] = 1);
            !currentRowData['total'] && (newData['total'] = info.cost);

        }

        if (prop == 'internalCode' && value) {
            let product = products.find(x => x.internalCode == value);
            if (product) {
                newData['productId'] = product.id;
                newData['presentation'] = product.presentation;
                newData['um'] = product.um;
                newData['family'] = product.family;
                newData['cost'] = product.cost;
                newData['price'] = product.price;
                newData['quantity'] = 1;
                newData['total'] = product.cost;
            }

        }

        if (prop == 'quantityRequest' && (+value) >= 0)
            newData['total'] = currentRowData['cost'] * value;

    }

    const setCellValueForResponse = (prop, newData, value, currentRowData) => {

        newData[prop] = value || 0;
        if (prop == 'quantityResponse' && (+value) >= 0)
            newData['total'] = currentRowData['cost'] * value;

    }

    const onValueChangedArea = (e) => {
        setAreaSourceId(e.value);
        setDetails([]);
    }

    const onRowInserting = (e) => {

        const isCanceled = new Promise((resolve, reject) => {

            const existsProduct = details.find(x => x.productId == e.data.productId);

            if (existsProduct) {
                notify(`El producto ya se encuentra en la lista`, 'error', 1000);
                reject(`El producto ya se encuentra en la lista`);
            } else {
                resolve(false);
            }
        });
        e.cancel = isCanceled;

    }

    const withOutDetaill = ({ traslateDetails, ...rest }) => rest;

    const textCreating = editing ? 'Modificar traslado ' + formatId(id) : 'Solicitar traslado';
    const textEditing = 'Despachar traslado';

    var itemHTML = isCreate ? <SimpleItem dataField="areaSourceId" editorType="dxSelectBox"
        editorOptions={{
            dataSource: createStoreLocal({ name: 'area' }),
            ...editorOptionsSelect,
            onValueChanged: onValueChangedArea
        }} >
        <Label text="Bodega" />
        <RequiredRule message="Seleccione la bodega" />
    </SimpleItem>
        :
        <SimpleItem dataField="areaTargetId" editorType="dxSelectBox"
            editorOptions={{
                dataSource: createStoreLocal({ name: 'area' }),
                ...editorOptionsSelect,
            }} >
            <Label text="Area solicitante" />
            <RequiredRule message="Seleccione la bodega" />
        </SimpleItem>

    return (
        <div>
            <Popup
                width={'95vw'}
                height={'95vh'}
                title={isCreate ? textCreating : `Despachar solicitud ${id}`}
                onHiding={onHiding}
                visible={open}
            >
                <Form formData={traslate} ref={refForm} readOnly={!isCreate}>
                    <GroupItem colCount={3}>
                        {itemHTML}

                        <SimpleItem dataField="date" editorType="dxDateBox"
                            editorOptions={{
                                displayFormat: 'dd/MM/yyyy',
                                openOnFieldClick: true,
                            }} >
                            <Label text="Fecha" />
                            <RequiredRule message="Seleccione la fecha" />
                        </SimpleItem>
                        <SimpleItem dataField="stepId" editorType="dxSelectBox"
                            editorOptions={{
                                disabled: true,
                                dataSource: createStoreLocal({ name: 'traslateStep' }),
                                ...editorOptionsSelect
                            }} >
                            <Label text="Etapa" />
                            <RequiredRule message="Seleccione la bodega" />
                        </SimpleItem>
                        <SimpleItem dataField="observation" colSpan={3} editorType="dxTextArea">
                            <Label text="Observacion" />
                            <RequiredRule message="Ingrese una observacion" />
                            <StringLengthRule max={500} message="Maximo 500 caracteres" />
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                        <DataGrid id="gridDetails"
                            ref={refGrid}
                            selection={{ mode: 'single' }}
                            dataSource={details}
                            showBorders={true}
                            showRowLines={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            height={'70vh'}
                            onToolbarPreparing={isCreate ? onToolbarPreparing : undefined}
                            onCellPrepared={onCellPrepared}
                            onRowInserting={onRowInserting}
                            keyboardNavigation={
                                {
                                    enterKeyDirection: 'column',
                                    enterKeyAction: 'startEdit',
                                }
                            }

                            editing={{
                                mode: 'cell',
                                allowUpdating: true,
                                selectTextOnEditStart: true,

                            }}
                        >
                            <Paging defaultPageSize={20} />
                            <Pager
                                showInfo={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 50]}
                            />
                            <Column dataField="internalCode" caption={'Código'} width={90} allowEditing={true} allowUpdating={isCreate} setCellValue={setCellValue.bind(null, "internalCode")}>
                                <RuleRequired />
                            </Column>
                            <Column dataField="productId" caption="Producto" allowEditing={isCreate}
                                setCellValue={setCellValue.bind(null, "productId")}
                                editCellComponent={props => <ProductDDBComponent showPrice={false} {...props} quantity='quantityRequest' />}>
                                <Lookup
                                    dataSource={products}
                                    valueExpr="id"
                                    displayExpr={item => item ? `${item.name}` : ''}

                                />
                                <RuleRequired />
                            </Column>
                            <Column dataField="family" caption={defaultLabels.family} width={120} allowEditing={false}>
                                <RuleRequired />
                            </Column>
                            <Column dataField="um" caption="Unidad Medida" width={120} allowEditing={false}></Column>
                            <Column dataField="quantityRequest"
                                caption="Cantidad Solic"
                                dataType="number" width={80}
                                allowEditing={isCreate}
                                setCellValue={setCellValue.bind(null, "quantityRequest")}>
                                <RuleRequired />
                            </Column>
                            <Column dataField="quantityResponse"
                                caption="Cantidad"
                                dataType="number" width={80}
                                visible={!isCreate}
                                setCellValue={setCellValueForResponse.bind(null, "quantityResponse")}>
                                <RuleRequired />
                            </Column>
                            <Column dataField="cost" caption="Costo" dataType="number" width={100} allowEditing={false} cellRender={cellRender()} >
                                <RuleRequired />
                            </Column>
                            <Column dataField="total" caption="Total" dataType="number" width={120} allowEditing={false} cellRender={cellRender()} >
                                <RuleRequired />
                            </Column>
                            <Column type="buttons" width={50}>
                                <ButtonGrid name="delete" />
                            </Column>
                            <Editing
                                mode="cell"
                                allowDeleting={true}
                                allowUpdating={true}
                                selectTextOnEditStart={true}
                                useIcons={true}
                            ></Editing>
                        </DataGrid>
                    </GroupItem>
                </Form>

                <ButtonForm
                    saving={saving}
                    textSaving={textCreating}
                    visible={isCreate && traslate.stepId == stepsTraslate.pendiente}
                    onClick={crearTraslado} />
                <ButtonForm
                    saving={saving}
                    textSaving={textEditing}
                    visible={!isCreate && traslate.stepId == stepsTraslate.pendiente}
                    onClick={despacharTraslado} />

            </Popup>
        </div>
    );
}

export default Nuevo;
